import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.Basics.title',
    defaultMessage: 'Let’s get to know each other',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.Basics.subtitle',
    defaultMessage: 'Please tell us a little bit about yourself, so we can get to know each other. \n\nOur team will reach out whenever there’s a job available for you, so please provide us with your contact information so that we can get in touch.',
  },
  firstnameLabel: {
    id: 'containers.SupplierProfile.components.Basics.firstname.label',
    defaultMessage: 'What\'s your first name?',
  },
  firstnamePlaceholder: {
    id: 'containers.SupplierProfile.components.Basics.firstname.placeholder',
    defaultMessage: 'Type in your first name here ',
  },
  lastnameLabel: {
    id: 'containers.SupplierProfile.components.Basics.lastname.label',
    defaultMessage: 'What\'s your last name?',
  },
  lastnamePlaceholder: {
    id: 'containers.SupplierProfile.components.Basics.lastname.placeholder',
    defaultMessage: 'Type in your last name here',
  },
  emailLabel: {
    id: 'containers.SupplierProfile.components.Basics.email.label',
    defaultMessage: 'What\'s your e-mail address?',
  },
  emailPlaceholder: {
    id: 'containers.SupplierProfile.components.Basics.email.placeholder',
    defaultMessage: 'your@email.com',
  },
  urlLabel: {
    id: 'containers.SupplierProfile.components.Basics.url.label',
    defaultMessage: 'If you have a website, where do we find it?',
  },
  urlPlaceholder: {
    id: 'containers.SupplierProfile.components.Basics.url.placeholder',
    defaultMessage: 'https://',
  },
  phoneNumberPrimaryLabel: {
    id: 'containers.SupplierProfile.components.Basics.phoneNumber.primary.label',
    defaultMessage: 'What\'s your primary phone number?',
  },
  phoneNumberSecondaryLabel: {
    id: 'containers.SupplierProfile.components.Basics.phoneNumber.secondary.label',
    defaultMessage: 'Additional phone number',
  },
  phoneNumberPlaceholder: {
    id: 'containers.SupplierProfile.components.Basics.phoneNumber.placeholder',
    defaultMessage: 'Select a country before entering your phone number',
  },
  phoneNumberSearchPlaceholder: {
    id: 'containers.SupplierProfile.components.Basics.phoneNumber.placeholder.search',
    defaultMessage: 'Search',
  },
  phoneNumberNotFoundPlaceholder: {
    id: 'containers.SupplierProfile.components.Basics.phoneNumber.placeholder.notfound',
    defaultMessage: 'Not found',
  },
  phoneNumberAdd: {
    id: 'containers.SupplierProfile.components.Basics.phoneNumber.add',
    defaultMessage: 'Add another phone number',
  },
  validationFailed: {
    id: 'containers.SupplierProfile.components.Basics.validationFailed',
    defaultMessage: 'Hold up. Something\'s missing. Did you fill out all the information correctly?',
  },
})
